///////////////////////////////////////////////////////
// Outline
///////////////////////////////////////////////////////
/*
    1. Interface
        a. init

    2. Helpers
        a. setFacilityCourses
        b. initializeCourse
        c. initializeTee
        d. initializeCRSL

    3. Property Accessors
        a. getFacility
        b. setFacility
        c. getCourse
        d. setCourse
        e. getTee
        f. setTee
        g. getMaxDate
        h. getMinDate

    4. Misc
        a. facilityChange
        b. courseChange
        c. isAssociationCourse
        d. isAssociationFacility
*/

(function () {
    'use strict';

    angular
        .module('app.shared')
        .component('sc3BaseScore', {
            templateUrl: 'app/shared/score-posting/base-score.component.html',
            controller: BaseScoreComponent,
            require: { form: '^^form' },
            bindings: {
                score: '<',
                facility: '<'
            }
        });

    var isUndefined = angular.isUndefined;

    BaseScoreComponent.$inject = ['$scope', 'Facility', 'Course', 'shared_resources', 'holesPlayed', '$timeout', 'alert', 'courseStatus', '$state', 'formatPlayed'];
    function BaseScoreComponent($scope, Facility, Course, resources, holesPlayed, $timeout, alert, courseStatus, $state, formatPlayed) {
        // Variables
        var ctrl = this, facility, course, tee;

        // Properties
        ctrl.form = null;
        ctrl.formatPlayed = formatPlayed.$metadata;
        ctrl.holesPlayed = holesPlayed.$metadata;        
        ctrl.datePickerOptions = { minDate: getMinDate(), maxDate: getMaxDate(), maxMode: 'day' };
        Object.defineProperty(ctrl, 'facility', { get: getFacility, set: setFacility });
        Object.defineProperty(ctrl, 'course', { get: getCourse, set: setCourse });
        Object.defineProperty(ctrl, 'tee', { get: getTee, set: setTee });
        Object.defineProperty(ctrl, 'isAdminPage', { get: getIsAdminPage });

        // Methods
        ctrl.$onInit = init;
        ctrl.facilityChange = facilityChange;
        ctrl.courseChange = courseChange;
        ctrl.isAssociationCourse = isAssociationCourse;
        ctrl.isAssociationFacility = isAssociationFacility;

        ///////////////////////////////////////////////////////
        // Interface
        ///////////////////////////////////////////////////////
        function init() {
            ctrl.score = ctrl.score || {};
            initializeCourse();
            initializeTee();
            initializeCRSL();            
        }

        ///////////////////////////////////////////////////////
        // Helpers
        ///////////////////////////////////////////////////////
        function setFacilityCourses(facility) {
            if (facility && facility.id) {
                Course.getCourses({ facilityId: facility.id, memberId: ctrl.score.individualId }, success, error);
            }

            function success(courses) {
                facility.courses = courses;
                if (courses.length === 1)
                    ctrl.course = courses[0];
            }
            function error(rejection) {
                var isCancellation = rejection && rejection.status === -1;
                if (!isCancellation)
                    alert.error(resources.courseListRequestFailed);
            }
        }
        function initializeCourse() {
            var score = ctrl.score,
                facility = ctrl.facility,
                courses = facility && facility.courses,
                courseId = score.courseId;

            var tc = courses && courses.length > 0 ? courses[0] : null;
            var fc = courses && courseId ? courses.find(find) : null;
            if (fc) {
                tc = fc;
            }
            ctrl.course = tc;

            function find(course) {
                return course.id === courseId;
            }
        }
        function initializeTee() {
            var score = ctrl.score,
                tees = course && course.tees,
                teeId = score.teeId;

            var tc = tees && tees.length > 0 ? tees[0] : null;
            var fc = tees && teeId ? tees.find(find) : null;
            if (fc) {
                tc = fc;
            }
            ctrl.tee = tc;

            function find(tee) {
                return tee.id === teeId;
            }
        }
        function initializeCRSL() {
            var score = ctrl.score;

            Object.defineProperty(score, '$$rating', { get: slopeRatingAccessor.bind(score, 'frontRating', 'backRating', 'rating') });
            Object.defineProperty(score, '$$slope', { get: slopeRatingAccessor.bind(score, 'frontSlope', 'backSlope', 'slope') });                    
            Object.defineProperty(score, '$$adjTargetScore', { get: slopeRatingAccessor.bind(score, '', '', 'adjustedTargetScore') });                    

            function slopeRatingAccessor(front, back, both) {
                var tee = ctrl.tee,
                    holes = this.holesPlayed,
                    field = holes === holesPlayed.FrontNine ? front : holes === holesPlayed.BackNine ? back : both;
                return tee && tee[field];
            }

            function targetScoreAccessor(adjTargetScore) {
                var tee = ctrl.tee,
                    holes = this.holesPlayed;

                if (holes === holesPlayed.EighteenHoles)
                    return tee && tee[field];
                else
                    return tee && 0;
            }
        }
        //function initializeTargetScore() {
        //    var score = ctrl.score;

        //    Object.defineProperty(score, '$$AdjTargetScore', { get: targetScoreAccessor.bind(score, 'adjustedTargetScore') });

        //    function targetScoreAccessor(adjTargetScore) {
        //        var tee = ctrl.tee,
        //            holes = this.holesPlayed;

        //        if (holes === holesPlayed.EighteenHoles)                
        //            return tee && tee[field];
        //        else
        //            return tee && 0;
        //    }
        //}


        ///////////////////////////////////////////////////////
        // Property Accessors
        ///////////////////////////////////////////////////////
        function getFacility() {
            return facility;
        }
        function setFacility(value) {
            if (facility != value) {
                ctrl.score.facilityId = (facility = value) && facility.id || null;
                setFacilityCourses(facility);
            }
        }
        function getCourse() {
            return course;
        }
        function setCourse(value) {
            ctrl.score.courseId = (course = value) && course.id || null;
        }
        function getTee() {
            return tee;
        }
        function setTee(value) {
            ctrl.score.setTee(tee = value);
            // ctrl.score.teeId = (tee = ctrl.score.$$tee = value) && tee.id || null;
        }
        function getMaxDate() {
            var now = new Date();
            return new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59, 999); // end of day
        }
        function getMinDate() {
            var now = new Date();
            now.setYear(now.getFullYear() - 2);
            return now;
        }

        ///////////////////////////////////////////////////////
        // Misc
        ///////////////////////////////////////////////////////
        function facilityChange() {
            var courseCtrl = ctrl.form.course;
            ctrl.course = null;
            if (courseCtrl)
                courseCtrl.$setUntouched();
            courseChange();
        }

        function courseChange() {
            var teeCtrl = ctrl.form.tee;
            ctrl.tee = null;
            teeCtrl.$setUntouched();
        }

        function isAssociationCourse(course) {
            return !course || course.courseStatus === courseStatus.Active;
        }

        function isAssociationFacility(facility) {
            return !facility || !facility.courses || facility.courses.length !== 1 || isAssociationCourse(facility.courses[0]);
        }
        function getIsAdminPage() {
            var data = $state.$current.data;
            return data && data.requireAdmin;
        }

    }
})();